import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IRetrievePanelStyles {
  root?: IStyle;
}

export interface IRetrievePanelClassNames {
  root: string;
}

export const retrievePanelStylesDefault = (_theme: IH2OTheme): Partial<IRetrievePanelStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});
